<template>
	<div class="page_div">
		<!-- <el-card class="box-card1">
			<div slot="header" class="clearfix">
				<span>落地页生成信息配置</span>
			</div>
			<el-form label-position="left" style="width: 75%;margin: 0 auto;" ref="form" :model="form1" label-width="120px">
				<el-form-item label="落地页名称:">
					<el-input v-model="form1.name"></el-input>
				</el-form-item>
				<el-form-item label="来源:">
					<el-input v-model="form1.source"></el-input>
				</el-form-item>
				<el-form-item label="渠道:">
					<el-input v-model="form1.channel"></el-input>
				</el-form-item>
				<el-form-item label="备注:">
					<el-input v-model="form1.remark"></el-input>
				</el-form-item>
				<el-form-item style="width: 100%;display: flex;justify-content: flex-start;margin-left: -7.5rem;">
					<el-radio-group v-model="form1.baiduPage">
						<el-radio :label="3">百度落地页</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="落地页网址:">
					<el-input v-model="form1.address"></el-input>
				</el-form-item>
				<el-form-item style="width: 100%;display: flex;justify-content: flex-start;margin-left:-7.5rem;">
					<el-radio-group v-model="form1.noBaiduPage">
						<el-radio :label="3">非百度落地页</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="落地页样式选择:"></el-form-item>
			</el-form>
			<div style="display: flex;justify-content: space-around;width: 80%;margin: 0 auto;">
				<div class="img_div" v-for="(item, index) in imgList" :key="index">
					<span class="demonstration">{{item.name}}</span>
					<img style="width: 11.71875rem;height: 25.375rem;" :src="item.url" fit="fit" />
				</div>
			</div>
		</el-card> -->
		
		<el-card class="box-card2">
			<div slot="header" class="clearfix">
				<span>落地页对话窗口信息配置</span>
			</div>
			<el-form label-position="left" style="width: 75%;margin: 0 auto;" ref="form" :model="form2" label-width="160px">
				<el-form-item label="落地页名称:">
					<el-input v-model="form2.name"></el-input>
				</el-form-item>
				<el-form-item label="标题:">
					<el-input v-model="form2.title"></el-input>
				</el-form-item>
				<el-form-item label="副标题:">
					<el-input v-model="form2.subTitle"></el-input>
				</el-form-item>
				<el-form-item label="客服人员对外显示名称:">
					<el-input v-model="form2.displayName"></el-input>
				</el-form-item>
				<!-- <el-form-item label="客服人员对外显示头像:">
					<el-input v-model="form2.displayIcon"></el-input>
				</el-form-item> -->
				<el-form-item label="客服人员对外显示头像:" ref="uploadElement" prop="logoUrl">
					<div class="upload_box" style="display: flex;flex-direction: row;justify-content: flex-start;">
						<el-input v-model="form2.displayIcon" v-if="false" @keyup.enter.native="nextInputMessage(3)"></el-input>
						<el-upload
							class="avatar-uploader"
							:action="avatarUrl"
							:show-file-list="false"
							:on-success="handleAvatarSuccess"
							:before-upload="beforeAvatarUpload"
							accept=".jpg,.jpeg,.png"
							style="margin-bottom:-17px ;"
						>
							<div style="display: flex;flex-direction: row;align-items: center;">
								<div class="logo_div" v-if="form2.displayIcon">
									<img :src="form2.displayIcon" class="logoUrl" />
								</div>
								<i v-else class="el-icon-plus avatar-uploader-icon" style="margin-left: 5px;"></i>
								<div v-if="!form2.displayIcon" class="el-upload__text" style="margin-right: 10px;margin-left: 5px;">设置头像</div>
							</div>
						</el-upload>
					</div>
				</el-form-item>
				<el-form-item label="医院名称:">
					<el-input v-model="form2.hoslName"></el-input>
				</el-form-item>
				<el-form-item label="医院地址:">
					<el-input v-model="form2.hosAddress"></el-input>
				</el-form-item>
				<el-form-item label="医院服务电话:">
					<el-input v-model="form2.hosPhone"></el-input>
				</el-form-item>
				<el-form-item label="医院微信号:">
					<el-input v-model="form2.hosWx"></el-input>
				</el-form-item>
				<el-form-item label="医院开放时间:">
					<el-input v-model="form2.hosTime"></el-input>
				</el-form-item>
				<el-form-item label="宣传图:">
					<el-upload class="upload-demo" :action="avatarUrl"
					 :on-remove="handleRemove" :file-list="fileList" list-type="picture"
					 :on-success="handleAvatarSuccess2"
					 :before-upload="beforeAvatarUpload2">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传340*160文件，且不超过500kb</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="落地页ICON:">
					<el-upload class="upload-demo" :action="avatarUrl"
					:file-list="iconList" list-type="picture"
					:on-remove="handleIconRemove"
					 :on-success="handleIconSuccess"
					 :before-upload="beforeIconUpload">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传ico文件，且不超过500kb</div>
					</el-upload>
				</el-form-item>
			</el-form>
		</el-card>
		<div style="margin-top: 2.5rem">
			<el-button type="primary" @click="onSubmit" style="width: 6.25rem;height: 2.8125rem;margin-right: 1.25rem;">保存</el-button>
			<el-button style="width: 6.25rem;height: 2.8125rem;" @click="back">取消</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'addpage',
		
		props:['projectItem', 'selectPage'],
		
		data() {
			return {
				form1: {
					name: '',
					source: '',
					channel: '',
					remark: '',
					baiduPage: '',
					address: '',
					noBaiduPage: ''
				},

				imgList: [{
						name: '样式一',
						url: require("../assets/skin_1.png"),
					},
					{
						name: '样式二',
						url: require('../assets/skin_2.png'),
					},
					{
						name: '样式三',
						url: require('../assets/skin_3.png'),
					}
				],
				fileList: [
					// {
					// 	name: 'food.jpeg',
					// 	url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
					// }
				],
				
				iconList: [
					{
						name:'',
						url:'http://medibot.online/resources' + '/image/default/favicon.ico'
					}
				],
				
				avatarUrl:'http://medibot.online:8040'+'/projectchat/fileInfo/pass/upload',
				// myHeaders:{
				// 	Authorization:localStorage.getItem("token")
				// },

				form2: {
					name: '',
					title: '',
					subTitle: '',
					displayName: '',
					displayIcon: '',
					hoslName: '',
					hosAddress: '',
					hosPhone: '',
					hosWx: '',
					hosTime: '',
					hosPicture: '',
					iconPicture:'http://medibot.online/resources' + '/image/default/favicon.ico'
				},
				nowProject: this.projectItem,
				editPage: this.selectPage,
			}
		},
		
		created() {
			console.log('addpage created nowProject = ', this.nowProject)
			console.log('addpage created editPage = ', this.editPage)
			if (this.editPage !== null) {
				this.form2.name = this.editPage.name
				this.form2.title = this.editPage.title
				this.form2.subTitle = this.editPage.subtitle
				this.form2.displayName = this.editPage.customerName
				this.form2.displayIcon = this.editPage.customerUrl
				this.form2.hoslName = this.editPage.hospitalName
				this.form2.hosAddress = this.editPage.hospitalAddress
				this.form2.hosPhone = this.editPage.hospitalTel
				this.form2.hosTime = this.editPage.bussinessHours
				this.form2.hosPicture = this.editPage.publicityPicturesUrl
				this.form2.hosWx = this.editPage.hospitalWx
				this.form2.iconPicture = this.editPage.iconUrl
				
				const obj = {
					url:this.form2.hosPicture
				}
				this.fileList.push(obj)
				
				const iconObj = {
					url:this.form2.iconPicture
				}
				this.iconList = []
				this.iconList.push(iconObj)
			}
		},

		methods: {
			handleRemove(file, fileList) {
				console.log('handleRemove ', file, fileList);
			},
			
			handleIconRemove(file, fileList) {
				console.log('handleIconRemove ',file, fileList);
				this.iconList = fileList
			},
			
			handlePreview(file) {
				console.log(file);
			},
			
			onSubmit() {
				console.log('addpage onSubmit')
				if (this.editPage === null) {
					this.addPageRequest()
				} else {
					this.editPageRequest()
				}
			},
			
			back() {
				console.log('addpage back')
				this.$emit('pageBack')
			},
			
			async addPageRequest() {
				console.log('addpage addPageRequest')
				if (this.iconList.length === 0) {
					this.$message.error('落地页ICON图片不能为空！')
					return
				}
				
				var api = "/projectchat/projectMessage/addOrEdit";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						projectId: this.nowProject.id,
						name: this.form2.name,
						title: this.form2.title,
						subtitle: this.form2.subTitle,
						customerName: this.form2.displayName,
						customerUrl: this.form2.displayIcon,
						hospitalName: this.form2.hoslName,
						hospitalAddress: this.form2.hosAddress,
						hospitalTel: this.form2.hosPhone,
						bussinessHours: this.form2.hosTime,
						publicityPicturesUrl: this.form2.hosPicture,
						hospitalWx: this.form2.hosWx,
						iconUrl:this.form2.iconPicture
					},
				});
				console.log("pagelist pageListRequest response = ", response);
				if (response.resultCode === '10000') {
					this.back()
				} else {
					this.$message.error(response.desc)
				}
			},
			
			async editPageRequest() {
				console.log('addpage editPageRequest')
				if (this.iconList.length === 0) {
					this.$message.error('落地页ICON图片不能为空！')
					return
				}
				
				var api = "/projectchat/projectMessage/addOrEdit";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						id: this.editPage.id,
						projectId: this.nowProject.id,
						name: this.form2.name,
						title: this.form2.title,
						subtitle: this.form2.subTitle,
						customerName: this.form2.displayName,
						customerUrl: this.form2.displayIcon,
						hospitalName: this.form2.hoslName,
						hospitalAddress: this.form2.hosAddress,
						hospitalTel: this.form2.hosPhone,
						bussinessHours: this.form2.hosTime,
						publicityPicturesUrl: this.form2.hosPicture,
						iconUrl: this.form2.iconPicture,
						hospitalWx: this.form2.hosWx
					},
				});
				console.log("pagelist editPageRequest response = ", response);
				if (response.resultCode === '10000') {
					this.back()
				} else {
					this.$message.error(response.desc)
				}
			},
			
			handleAvatarSuccess(res,file) {
				
				this.form2.displayIcon = 'http://medibot.online/resources' + res.data.fileUrl
				console.log("图片URL",this.form2.displayIcon)
				console.log("上传图片成功",res)
				console.log(file)
			},
			
			beforeAvatarUpload(file) {
				const isJPG = file.type === "image/png" || "image/jpg" || "image/jpeg";
				const isLt2M = file.size / 1024 / 1024 < 2;
						
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG/PNG/JPEG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			
			handleAvatarSuccess2(res,file) {
				this.form2.hosPicture = 'http://medibot.online/resources' + res.data.fileUrl
				console.log("图片URL2",this.form2.hosPicture)
				console.log("上传图片成功2",res)
				
				this.fileList = []
				const obj = {
					url: this.form2.hosPicture
				}
				this.fileList.push(obj)
			},
			
			beforeAvatarUpload2(file) {
				const isJPG = file.type === "image/png" || "image/jpg" || "image/jpeg";
				const isLt2M = file.size / 1024 / 1024 < 2;
						
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG/PNG/JPEG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			
			handleIconSuccess(res,file) {
				this.form2.iconPicture = 'http://medibot.online/resources' + res.data.fileUrl
				console.log("图片icon Url",this.form2.iconPicture)
				console.log("上传icon图片成功2",res)
				
				this.iconList = []
				const obj = {
					url: this.form2.iconPicture
				}
				this.iconList.push(obj)
			},
			
			beforeIconUpload(file) {
				console.log('beforeIconUpload file = ', file)
				const isJPG = file.type === "image/vnd.microsoft.icon";
				const isLt2M = file.size / 1024 / 1024 < 2;
						
				if (!isJPG) {
					this.$message.error('上传图标图片只能是ico格式，尺寸32*32!');
				}
				if (!isLt2M) {
					this.$message.error('上传图标图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
		}

	}
</script>

<style scoped="scoped">
	.page_div {
		width: 95%;
		height: 47.5rem;
		overflow: scroll;
		margin: 0 auto;
	}

	.clearfix {
		display: flex;
		justify-content: flex-start;
	}

	.box-card1,
	.box-card2 {
		height: 75rem;
		width: 80%;
		margin: 0 auto;
	}
	
	.box-card1 {
		height: 8.75rem;
	}

	.box-card2 {
		height: 77rem;
		/* margin-top: 1.25rem; */
	}

	.img_div {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		/* border: 0.125rem solid #2C3E50; */
	}

	.img_div:hover {
		border: 1px solid #5A9CF8;
	}

	.demonstration {
		font-size: 0.875rem;
		font-family: "Helvetica Neue";
	}

	.upload-demo {
		/* background-color: chocolate; */
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		padding-bottom: 1.25rem;
	}

	.el-upload__tip {
		margin-top: -0.625rem;
	}
	
	.logo_div {
		width:70px;
		height:60px;
		border:none;
		display: table-cell;
		vertical-align: middle;
	}
	
	.logo_div img {
		max-width: 100%;
		max-height: 100%;
		display: block;
		margin: auto;
	}
</style>
